package com.eladfinish.bible.contest.di

import com.eladfinish.bible.contest.analytics.InstallationIdUserProperty
import com.eladfinish.bible.contest.analytics.SetUserPropertiesUseCase
import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.analytics.crashlytics.ExceptionReporter
import com.eladfinish.bible.contest.common.json
import com.eladfinish.bible.contest.common.random.KotlinRandomProvider
import com.eladfinish.bible.contest.common.random.RandomProvider
import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import com.eladfinish.bible.contest.common.settings.RusshwolfKeyValueSettings
import com.eladfinish.bible.contest.common.usecases.AddGershaimUseCase
import com.eladfinish.bible.contest.common.usecases.GetBookAndChapterPrefixedByPerekUseCase
import com.eladfinish.bible.contest.common.usecases.GetContentOfChapterUseCase
import com.eladfinish.bible.contest.common.usecases.GetHighlightedVerseMarkupRangeUseCase
import com.eladfinish.bible.contest.common.usecases.MakeOtiotPasukSmallerUseCase
import com.eladfinish.bible.contest.common.usecases.MakeOtiotPerekBoldUseCase
import com.eladfinish.bible.contest.common.usecases.PartitionChapterUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveColonSplitterUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveGodNamesUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveNikudAndMakafUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveNikudAndTeamimAndMakafUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveNikudAndTeamimIfNeedUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveNikudUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveTeamimAndMakafUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveTeamimUseCase
import com.eladfinish.bible.contest.common.usecases.SendReportToGoogleFormUseCaseKMP
import com.eladfinish.bible.contest.common.usecases.getSpecificVerse.GetSpecificVerseV3UseCase
import com.eladfinish.bible.contest.currentMilliseconds
import com.eladfinish.bible.contest.data.common.ClipboardCopier
import com.eladfinish.bible.contest.data.common.MyClipboardManager
import com.eladfinish.bible.contest.features.hebrewCalendar.GetCurrentParashaUseCase
import com.eladfinish.bible.contest.features.hebrewCalendar.GetTodayHebrewDateUseCase
import com.eladfinish.bible.contest.features.teruma.ResolveAboutTerumaUseCase
import com.eladfinish.bible.contest.features.verseWidget.isVerseWidgetPlatform
import com.eladfinish.bible.contest.network.ApiBaseUrlProvider
import com.eladfinish.bible.contest.platform.isAndroid
import com.eladfinish.bible.contest.platform.isIos
import com.eladfinish.bible.contest.screens.americanQuestions.usecases.GetAmericanQuestionsUseCase
import com.eladfinish.bible.contest.screens.americanQuestions.usecases.LoadPairsAsMultiChoiceQuestionsUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.BuildPartReadyStateUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.FetchChapterDataUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetContentForBibleModeUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetContentForSedarimModeUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetContentUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetIyovTehilimSpeakersUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetSederContentUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetTableRowsUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetTehilim119UseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetTikunKorimFormatUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetTiqunHaklaliUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.HaftarotUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.MakeOtiotAliyahSmallerUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.MarkAliyotUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.PrepareChapterContentForDisplayUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.PrepareHtmlForPdfUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.RenumberOtiotPasukUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.SaveChapterFileUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.chumash.GetContentForChumashModeUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.chumash.GetParashaContentUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.chumash.GetParashaNameSpannedUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.chumash.GetShmotUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.shonot.GetParashatHaManContentUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.shonot.GetRoshChodeshContentUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.shonot.GetShonotContentUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.shonot.GetTaanitTziburContentUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.shonot.ShonotUseCaseProvider
import com.eladfinish.bible.contest.screens.browse.usecases.shonot.ShonotUseCaseProviderImpl
import com.eladfinish.bible.contest.screens.chapterComplete.features.createCompletions.BuildUserCompletionsModelUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.features.createCompletions.RenderUserCompletionsUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.features.createCompletions.ToggleUserBlankUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.features.createCompletions.UserCompletionsRenderer
import com.eladfinish.bible.contest.screens.chapterComplete.features.progressiveExposure.VerseOrHalfOrWordCompletionUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.features.shuffle.BuildShuffledVersesUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.AppendBlankWithRevealSpanUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.BuildContentByExposureTypeDomainUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.BuildLexicographicalTableHtmlUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.BuildSavedCompletionOutputUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.BuildVerseEntitiesFromChapterUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.ChapterCompleteUseCaseProvider
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.ChapterCompleteUseCaseProviderImpl
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.GetJsonEncodedBlanksUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.GetPresetBlanksUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.ParseSavedCompletionDataUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.ProcessRemoteBlanksUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.RevealBlankUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.SortVersesByMikudUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.SortVersesFullBookUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.SortVersesLexicographicallyUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.SortVersesSingleChapterUseCase
import com.eladfinish.bible.contest.screens.completeVerse.usecases.GetAllOptionsToCompleteUseCase
import com.eladfinish.bible.contest.screens.completeVerse.usecases.GetHalfVerseUseCase
import com.eladfinish.bible.contest.screens.completeVerse.usecases.GetHelpContentUseCase
import com.eladfinish.bible.contest.screens.completeVerse.usecases.GetIndexOfNextMissingWordUseCase
import com.eladfinish.bible.contest.screens.completeVerse.usecases.GetRandomVerseUseCase
import com.eladfinish.bible.contest.screens.completeVerse.usecases.GetWordVersionsUseCase
import com.eladfinish.bible.contest.screens.lexicographicalSort.GetVerseCountUseCase
import com.eladfinish.bible.contest.screens.lexicographicalSort.LexicographicalSortLogicUseCase
import com.eladfinish.bible.contest.screens.lexicographicalSort.LexicographicalSortPdfViewerStore
import com.eladfinish.bible.contest.screens.lexicographicalSort.LexicographicalSortStore
import com.eladfinish.bible.contest.screens.lexicographicalSort.usecases.SortLexicographicallyWebViewUseCase
import com.eladfinish.bible.contest.screens.main.ButtonListOrderRepository
import com.eladfinish.bible.contest.screens.main.pastQuizzesSheet.PastQuizzesSheetGate
import com.eladfinish.bible.contest.screens.main.usecases.EvenButtonGridUseCase
import com.eladfinish.bible.contest.screens.main.usecases.GetAnnouncementUseCase
import com.eladfinish.bible.contest.screens.main.usecases.GetMainScreenButtonListUseCase
import com.eladfinish.bible.contest.screens.main.usecases.GetRemoteFileContentUseCase
import com.eladfinish.bible.contest.screens.main.usecases.GetTelegramChannelUrlUseCase
import com.eladfinish.bible.contest.screens.main.usecases.StoredAppVersionUseCase
import com.eladfinish.bible.contest.screens.main.verseWidgetSheet.VerseWidgetSheetGate
import com.eladfinish.bible.contest.screens.monopoly.usecases.GetMonopolyDataUseCase
import com.eladfinish.bible.contest.screens.names.GetNamesUseCase
import com.eladfinish.bible.contest.screens.names.NamesLoader
import com.eladfinish.bible.contest.screens.openQuestions.usecases.BuildNumbersByBooksQuestionsUseCase
import com.eladfinish.bible.contest.screens.openQuestions.usecases.BuildQuestionsFromSheetUseCase
import com.eladfinish.bible.contest.screens.openQuestions.usecases.GetGoogleDriveDataUseCase
import com.eladfinish.bible.contest.screens.openQuestions.usecases.GetGoogleScriptDataUseCase
import com.eladfinish.bible.contest.screens.openQuestions.usecases.GetQuestionItemJsonListUseCase
import com.eladfinish.bible.contest.screens.openQuestions.usecases.GetQuestionsAndAnswersUseCase
import com.eladfinish.bible.contest.screens.openQuestions.usecases.GetTopicWithLinksUseCase
import com.eladfinish.bible.contest.screens.openQuestions.usecases.GetTopicsUseCase
import com.eladfinish.bible.contest.screens.openQuestions.usecases.TurnPairsToOpenQuestionsUseCase
import com.eladfinish.bible.contest.screens.openQuestions.usecases.ValidateEmailUseCase
import com.eladfinish.bible.contest.screens.pairMatching.usecases.GetPairsUseCase
import com.eladfinish.bible.contest.screens.pairMatching.usecases.SortableUseCase
import com.eladfinish.bible.contest.screens.pairMatching.usecases.TransformToMultiChoiceQuestionsUseCase
import com.eladfinish.bible.contest.screens.pastQuizzes.GetPastQuizzesConfigUseCase
import com.eladfinish.bible.contest.screens.pyramidCrossword.usecases.GetPyramidsUseCase
import com.eladfinish.bible.contest.screens.randomVerse.usecases.BuildChapterDialogFromVerse
import com.eladfinish.bible.contest.screens.randomVerse.usecases.GenerateMultipleRandomVersesUseCase
import com.eladfinish.bible.contest.screens.randomVerse.usecases.GetNamesToHideUseCase
import com.eladfinish.bible.contest.screens.randomVerse.usecases.HidePeopleNamesUsecase
import com.eladfinish.bible.contest.screens.randomVerse.usecases.ShowIyovFriendsUseCase
import com.eladfinish.bible.contest.screens.randomVerse.usecases.ShowSubTopicsUseCase
import com.eladfinish.bible.contest.screens.search.SearchUseCaseProvider
import com.eladfinish.bible.contest.screens.search.SearchUseCaseProviderImpl
import com.eladfinish.bible.contest.screens.search.ai.AiSearchRepository
import com.eladfinish.bible.contest.screens.search.ai.AiSearchRepositoryImpl
import com.eladfinish.bible.contest.screens.search.ai.GetAiSearchSuggestionUseCase
import com.eladfinish.bible.contest.screens.search.ai.GetAiSearchSuggestionUseCaseImpl
import com.eladfinish.bible.contest.screens.search.ai.remote.OpenAiApiKeyProvider
import com.eladfinish.bible.contest.screens.search.ai.remote.OpenAiApiKeyProviderTemp
import com.eladfinish.bible.contest.screens.search.analytics.AnonymousInstallationIdProvider
import com.eladfinish.bible.contest.screens.search.analytics.SearchAnalyticsEventFactory
import com.eladfinish.bible.contest.screens.search.analytics.SearchAnalyticsTracker
import com.eladfinish.bible.contest.screens.search.analytics.SettingsAnonymousInstallationIdProvider
import com.eladfinish.bible.contest.screens.search.api.KtorSearchAnalyticsApi
import com.eladfinish.bible.contest.screens.search.api.SearchAnalyticsApi
import com.eladfinish.bible.contest.screens.search.data.SearchRepository
import com.eladfinish.bible.contest.screens.search.data.SearchRepositoryImpl
import com.eladfinish.bible.contest.screens.search.history.RecordSearchHistoryUseCase
import com.eladfinish.bible.contest.screens.search.history.SearchHistoryHint
import com.eladfinish.bible.contest.screens.search.history.SearchHistoryRepository
import com.eladfinish.bible.contest.screens.search.history.SettingsSearchHistoryRepository
import com.eladfinish.bible.contest.screens.search.suggestions.CachedPopularSearchesRepository
import com.eladfinish.bible.contest.screens.search.suggestions.GetAutocompleteSuggestionsUseCase
import com.eladfinish.bible.contest.screens.search.suggestions.KtorPopularSearchesApi
import com.eladfinish.bible.contest.screens.search.suggestions.PopularSearchesApi
import com.eladfinish.bible.contest.screens.search.suggestions.PopularSearchesRepository
import com.eladfinish.bible.contest.screens.search.suggestions.RemoteConfigSearchSuggestionsConfigProvider
import com.eladfinish.bible.contest.screens.search.suggestions.SearchSuggestionsConfigProvider
import com.eladfinish.bible.contest.screens.search.usecases.BuildLocalSearchRequestUseCase
import com.eladfinish.bible.contest.screens.search.usecases.BuildSearchResultSourceUseCase
import com.eladfinish.bible.contest.screens.search.usecases.BuildSearchTerminationMessageUseCase
import com.eladfinish.bible.contest.screens.search.usecases.ExecuteLocalSearchUseCase
import com.eladfinish.bible.contest.screens.search.usecases.ExtractSpecialSearchQueryUseCase
import com.eladfinish.bible.contest.screens.search.usecases.GetChapterVersesUseCase
import com.eladfinish.bible.contest.screens.search.usecases.GetPostSearchSuggestionsUseCase
import com.eladfinish.bible.contest.screens.search.usecases.GetSearchFactsUseCase
import com.eladfinish.bible.contest.screens.search.usecases.GetSearchedChaptersUseCase
import com.eladfinish.bible.contest.screens.search.usecases.GetSpecialSignsUseCase
import com.eladfinish.bible.contest.screens.search.usecases.GetTextToCopyFromTextFieldUseCase
import com.eladfinish.bible.contest.screens.search.usecases.IncreaseNumberOfSearchesUseCase
import com.eladfinish.bible.contest.screens.search.usecases.InsertTextAtCursorUseCase
import com.eladfinish.bible.contest.screens.search.usecases.LinkToExamplesUseCase
import com.eladfinish.bible.contest.screens.search.usecases.NavigateToAdjacentChapterUseCase
import com.eladfinish.bible.contest.screens.search.usecases.PickVerseFromChapterUseCaseV2
import com.eladfinish.bible.contest.screens.search.usecases.SaveSearchResultsToFileUseCase
import com.eladfinish.bible.contest.screens.search.usecases.SearchChapterMatchesToSearchResultUiModelsUseCase
import com.eladfinish.bible.contest.screens.search.usecases.SearchUseCase
import com.eladfinish.bible.contest.screens.search.usecases.copy.PrepareSingleSearchResultToCopyUseCase
import com.eladfinish.bible.contest.screens.search.usecases.copy.PrepareTextToCopyUseCase
import com.eladfinish.bible.contest.screens.search.usecases.date.ParseDateQueryUseCase
import com.eladfinish.bible.contest.screens.search.usecases.date.SearchDateUseCase
import com.eladfinish.bible.contest.screens.search.usecases.engine.PrepareLocalSearchRequestUseCase
import com.eladfinish.bible.contest.screens.search.usecases.engine.SearchChapterUseCase
import com.eladfinish.bible.contest.screens.search.usecases.facts.ExecuteSpecialSearchUseCase
import com.eladfinish.bible.contest.screens.search.usecases.facts.MapSpecialSearchItemsToUiModelsUseCase
import com.eladfinish.bible.contest.screens.search.usecases.number.ParseBackendHighlightedContentUseCase
import com.eladfinish.bible.contest.screens.search.usecases.number.SearchNumberUseCase
import com.eladfinish.bible.contest.screens.search.usecases.root.FindWordRangesInVerseUseCase
import com.eladfinish.bible.contest.screens.search.usecases.root.RootSearchVerseProvider
import com.eladfinish.bible.contest.screens.search.usecases.root.RootSearchVerseProviderImpl
import com.eladfinish.bible.contest.screens.search.usecases.root.SearchRootUseCase
import com.eladfinish.bible.contest.screens.search.usecases.searchSuggestion.BuildSearchSuggestionUseCase
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.VersesPerAliyot
import com.eladfinish.bible.contest.screens.search.usecases.specialSearch.WordsPerParashot
import com.eladfinish.bible.contest.screens.settings.debug.DebugFlagsRepository
import com.eladfinish.bible.contest.ui.ads.AdBannerSuppression
import com.eladfinish.bible.contest.ui.components.toolbar.autohide.ToolbarAutoHide
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val presentationModule = module {
    includes(presentationModulePlatform)
}

val mainScreenModule = module {
    singleOf(::ButtonListOrderRepository)
    factoryOf(::StoredAppVersionUseCase)
    factoryOf(::GetRemoteFileContentUseCase)
    factoryOf(::ResolveAboutTerumaUseCase)
    factoryOf(::SetUserPropertiesUseCase)
    factory {
        InstallationIdUserProperty(
            settings = get(),
            installationIdProvider = get(),
            firebaseAnalyticsRepository = get(),
        )
    }
    factoryOf(::GetMainScreenButtonListUseCase)
    factoryOf(::GetAnnouncementUseCase)
    factoryOf(::GetTelegramChannelUrlUseCase)
    factoryOf(::GetPastQuizzesConfigUseCase)
    factory {
        PastQuizzesSheetGate(
            settings = get(),
            remoteConfigRepository = get(),
            isSupportedPlatform = isAndroid || isIos,
        )
    }
    factory {
        VerseWidgetSheetGate(
            settings = get(),
            remoteConfigRepository = get(),
            isSupportedPlatform = isVerseWidgetPlatform,
        )
    }
    singleOf(::AdBannerSuppression)
    singleOf(::ToolbarAutoHide)
    factoryOf(::EvenButtonGridUseCase)
}

val searchModule = module {
    single<ExceptionReporter> { ExceptionReporter(AppCrashlytics::logException) }
    factoryOf(::SearchUseCase)
    factoryOf(::LinkToExamplesUseCase)
    factoryOf(::GetSpecialSignsUseCase)
    factoryOf(::PrepareTextToCopyUseCase)
    factoryOf(::PrepareSingleSearchResultToCopyUseCase)
    factoryOf(::GetSearchFactsUseCase)
    factoryOf(::SearchNumberUseCase)
    factoryOf(::SearchRootUseCase)
    factoryOf(::SearchDateUseCase)
    factoryOf(::ParseDateQueryUseCase)
    factoryOf(::FindWordRangesInVerseUseCase)
    factoryOf(::ParseBackendHighlightedContentUseCase)
    factoryOf(::GetSearchedChaptersUseCase)
    factoryOf(::GetChapterVersesUseCase)

    factoryOf(::NavigateToAdjacentChapterUseCase)
    factoryOf(::SaveSearchResultsToFileUseCase)
    factoryOf(::ExecuteSpecialSearchUseCase)
    factoryOf(::MapSpecialSearchItemsToUiModelsUseCase)
    factoryOf(::SearchChapterUseCase)
    factoryOf(::PrepareLocalSearchRequestUseCase)
    factoryOf(::SearchChapterMatchesToSearchResultUiModelsUseCase)
    factoryOf(::BuildSearchResultSourceUseCase)
    factoryOf(::ExecuteLocalSearchUseCase)
    factoryOf(::BuildLocalSearchRequestUseCase)
    factoryOf(::BuildSearchTerminationMessageUseCase)
    factoryOf(::ExtractSpecialSearchQueryUseCase)
    factoryOf(::InsertTextAtCursorUseCase)
    factoryOf(::GetTextToCopyFromTextFieldUseCase)
    factoryOf(::GetPostSearchSuggestionsUseCase)
    factoryOf(::BuildSearchSuggestionUseCase)
    factoryOf(::IncreaseNumberOfSearchesUseCase)

    factoryOf(::SearchRepositoryImpl) bind SearchRepository::class
    // single: its Mutex must be shared by every writer
    single<SearchHistoryRepository> { SettingsSearchHistoryRepository(settings = get()) }
    factoryOf(::RecordSearchHistoryUseCase)
    factoryOf(::SearchHistoryHint)

    // Search suggestions: the snapshot is held in memory once, so the repository is a single
    factoryOf(::KtorPopularSearchesApi) bind PopularSearchesApi::class
    factoryOf(::RemoteConfigSearchSuggestionsConfigProvider) bind SearchSuggestionsConfigProvider::class
    single<PopularSearchesRepository> {
        CachedPopularSearchesRepository(
            api = get(),
            configProvider = get(),
            fileStorage = get(),
            settings = get(),
            assetReader = get(),
            json = json,
            clock = { currentMilliseconds },
        )
    }
    factoryOf(::GetAutocompleteSuggestionsUseCase)
    factory { DebugFlagsRepository(settings = get()) }
    factoryOf(::RootSearchVerseProviderImpl) bind RootSearchVerseProvider::class
    // explicit: more constructor parameters than factoryOf supports (22)
    factory<SearchUseCaseProvider> {
        SearchUseCaseProviderImpl(
            getSpecialSignsUseCase = get(),
            linkToExamplesUseCase = get(),
            prepareLocalSearchRequestUseCase = get(),
            executeLocalSearchUseCase = get(),
            getSearchedChaptersUseCase = get(),
            searchNumberUseCase = get(),
            searchRootUseCase = get(),
            searchDateUseCase = get(),
            extractSpecialSearchQueryUseCase = get(),
            buildLocalSearchRequestUseCase = get(),
            buildSearchTerminationMessageUseCase = get(),
            getHighlightedVerseMarkupRangeUseCase = get(),
            makeOtiotPasukSmallerUseCase = get(),
            navigateToAdjacentChapterUseCase = get(),
            getSearchFactsUseCase = get(),
            executeSpecialSearchUseCase = get(),
            getAiSearchSuggestionUseCase = get(),
            insertTextAtCursorUseCase = get(),
            getTextToCopyFromTextFieldUseCase = get(),
            saveSearchResultsToFileUseCase = get(),
            getPostSearchSuggestionsUseCase = get(),
            buildSearchSuggestionUseCase = get(),
            increaseNumberOfSearchesUseCase = get(),
        )
    }

    includes(
        module {
            factoryOf(::AiSearchRepositoryImpl) bind AiSearchRepository::class
            factoryOf(::GetAiSearchSuggestionUseCaseImpl) bind GetAiSearchSuggestionUseCase::class
            factoryOf(::OpenAiApiKeyProviderTemp) bind OpenAiApiKeyProvider::class
        }
    )

    includes(
        module {
            single<SearchAnalyticsApi> {
                KtorSearchAnalyticsApi(
                    httpClient = get(),
                    baseUrl = get<ApiBaseUrlProvider>().getBaseUrl(),
                )
            }

            singleOf(::SettingsAnonymousInstallationIdProvider) bind AnonymousInstallationIdProvider::class
            singleOf(::SearchAnalyticsEventFactory)
            singleOf(::SearchAnalyticsTracker)
        }
    )

    factory { params ->
        VersesPerAliyot(
            getParashaContentUseCase = get(),
            getParashotUseCase = get(),
            settings = get(),
            versesStatisticsType = params.get(),
        )
    }

    factoryOf(::WordsPerParashot)
}

val americanQuestionsModule = module {
    factoryOf(::GetAmericanQuestionsUseCase)
    factoryOf(::TransformToMultiChoiceQuestionsUseCase)
    factoryOf(::LoadPairsAsMultiChoiceQuestionsUseCase)
    // Bridge MyClipboardManager (platform expect class) to the ClipboardCopier interface
    single<ClipboardCopier> { ClipboardCopier { text -> get<MyClipboardManager>().copyToClipboard(text) } }
}

val openQuestionsModule = module {
    factoryOf(::GetTopicsUseCase)
    factoryOf(::GetQuestionsAndAnswersUseCase)
    factoryOf(::GetTopicWithLinksUseCase)
    factoryOf(::TurnPairsToOpenQuestionsUseCase)
    factoryOf(::GetGoogleScriptDataUseCase)
    factoryOf(::GetGoogleDriveDataUseCase)
    factoryOf(::GetQuestionItemJsonListUseCase)
    factoryOf(::ValidateEmailUseCase)
    factoryOf(::BuildQuestionsFromSheetUseCase)
    factoryOf(::BuildNumbersByBooksQuestionsUseCase)
}

val namesModule = module {
    factoryOf(::GetNamesUseCase) bind NamesLoader::class
}

val browseModule = module {
    factoryOf(::BuildPartReadyStateUseCase)
    factoryOf(::FetchChapterDataUseCase)
    factoryOf(::MarkAliyotUseCase)
    factoryOf(::GetContentUseCase)
    factoryOf(::GetParashaContentUseCase)
    factoryOf(::GetSederContentUseCase)
    factoryOf(::GetTableRowsUseCase)
    factoryOf(::GetParashaNameSpannedUseCase)
    factoryOf(::GetTiqunHaklaliUseCase)
    factoryOf(::GetTehilim119UseCase)
    factoryOf(::RenumberOtiotPasukUseCase)
    factoryOf(::SortLexicographicallyWebViewUseCase)
    factoryOf(::PrepareChapterContentForDisplayUseCase)
    factoryOf(::GetContentForBibleModeUseCase)
    factoryOf(::GetContentForChumashModeUseCase)
    factoryOf(::GetContentForSedarimModeUseCase)
    factoryOf(::GetTikunKorimFormatUseCase)
    factoryOf(::GetShmotUseCase)
    factoryOf(::MakeOtiotAliyahSmallerUseCase)
    factoryOf(::SaveChapterFileUseCase)
}

val shonotModule = module {
    factoryOf(::GetRoshChodeshContentUseCase)
    factoryOf(::GetParashatHaManContentUseCase)
    factoryOf(::GetShonotContentUseCase)
    factoryOf(::GetTaanitTziburContentUseCase)
    factoryOf(::ShonotUseCaseProviderImpl) bind ShonotUseCaseProvider::class
}

val pyramidCrosswordModule = module {
    factoryOf(::GetPyramidsUseCase)
}

val monopolyModule = module {
    factoryOf(::GetMonopolyDataUseCase)
}

val completeVerseModule = module {
    factoryOf(::GetHalfVerseUseCase)
    factoryOf(::GetAllOptionsToCompleteUseCase)
    factoryOf(::GetHelpContentUseCase)
    factoryOf(::GetIndexOfNextMissingWordUseCase)
    factoryOf(::GetRandomVerseUseCase)
    factoryOf(::GetWordVersionsUseCase)
}

val completeChapterModule = module {
    factoryOf(::GetPresetBlanksUseCase)
    factoryOf(::ParseSavedCompletionDataUseCase)
    factoryOf(::ProcessRemoteBlanksUseCase)
    factoryOf(::GetJsonEncodedBlanksUseCase)
    factoryOf(::RusshwolfKeyValueSettings) bind KeyValueSettings::class
    factoryOf(::KotlinRandomProvider) bind RandomProvider::class
    factoryOf(::AppendBlankWithRevealSpanUseCase)
    factoryOf(::BuildSavedCompletionOutputUseCase)
    factoryOf(::BuildContentByExposureTypeDomainUseCase)
    factoryOf(::RevealBlankUseCase)
    factoryOf(::BuildUserCompletionsModelUseCase)
    factoryOf(::RenderUserCompletionsUseCase)
    factoryOf(::ToggleUserBlankUseCase)
    factoryOf(::UserCompletionsRenderer)
    factoryOf(::VerseOrHalfOrWordCompletionUseCase)
    factoryOf(::ChapterCompleteUseCaseProviderImpl) bind ChapterCompleteUseCaseProvider::class

    factoryOf(::BuildShuffledVersesUseCase)
}

val sortLexicographicallyModule = module {
    factoryOf(::PartitionChapterUseCase)
    factoryOf(::BuildVerseEntitiesFromChapterUseCase)
    factoryOf(::SortVersesSingleChapterUseCase)
    factoryOf(::SortVersesByMikudUseCase)
    factoryOf(::SortVersesFullBookUseCase)
    factoryOf(::SortVersesLexicographicallyUseCase)
    factoryOf(::BuildLexicographicalTableHtmlUseCase)
    factoryOf(::PrepareHtmlForPdfUseCase)
}

val lexicographicalSortScreenModule = module {
    factoryOf(::LexicographicalSortStore)
    factoryOf(::LexicographicalSortLogicUseCase)
    factoryOf(::GetVerseCountUseCase)
    factoryOf(::LexicographicalSortPdfViewerStore)
}

val parashotModule = module {
    factoryOf(::HaftarotUseCase)
}

val reportToGoogleFormModuleKMP = module {
    factoryOf(::SendReportToGoogleFormUseCaseKMP)
}

val viewContentTabsModule = module {
    factoryOf(::GetIyovTehilimSpeakersUseCase)
}

val pairMatchingModule = module {
    factoryOf(::GetPairsUseCase)
    factoryOf(::SortableUseCase)
}

val randomVerseModule = module {
    factoryOf(::GetIyovTehilimSpeakersUseCase)
    factoryOf(::ShowIyovFriendsUseCase)
    factoryOf(::ShowSubTopicsUseCase)
    factoryOf(::HidePeopleNamesUsecase)
    factoryOf(::GetNamesToHideUseCase)
    factoryOf(::BuildChapterDialogFromVerse)
    factoryOf(::GenerateMultipleRandomVersesUseCase)
}

val generalModule = module {
    factoryOf(::GetTodayHebrewDateUseCase)
    factoryOf(::GetCurrentParashaUseCase)
    factoryOf(::MakeOtiotPasukSmallerUseCase)
    factoryOf(::GetSpecificVerseV3UseCase)
    factoryOf(::PickVerseFromChapterUseCaseV2)
    factoryOf(::GetHighlightedVerseMarkupRangeUseCase)
    factoryOf(::MakeOtiotPerekBoldUseCase)
    factoryOf(::AddGershaimUseCase)
    factoryOf(::GetContentOfChapterUseCase)
    factoryOf(::GetBookAndChapterPrefixedByPerekUseCase)
    factoryOf(::RemoveNikudAndTeamimIfNeedUseCase)
    factoryOf(::RemoveNikudAndMakafUseCase)
    factoryOf(::RemoveNikudAndTeamimAndMakafUseCase)
    factoryOf(::RemoveColonSplitterUseCase)
    factoryOf(::RemoveGodNamesUseCase)
    factoryOf(::RemoveNikudUseCase)
    factoryOf(::RemoveTeamimUseCase)
    factoryOf(::RemoveTeamimAndMakafUseCase)
}
